import Link from "next/link";
import {
	COMPANY_FACEBOOK,
	COMPANY_INSTAGRAM,
	COMPANY_LINKEDIN,
	COMPANY_TWITTER,
	COMPANY_YOUTUBE,
} from "../../utils/constants";
import {
	FacebookIcon,
	LinkedinIcon,
	LoginIcon,
	TwitterIcon,
	YouTubeIcon,
	InstagramIcon
} from "../common/SocialIcons";

const SocialMedias = () => {
	return (
		<ul className='social flex   ' style={{
			gap: "10px"
		}}>
			<li className="icon ">
				<a href={COMPANY_INSTAGRAM} rel='noreferrer' target='_blank'>
					<InstagramIcon />
				</a>
			</li>
			
			<li className="icon ">
				<a href={COMPANY_TWITTER} rel='noreferrer' target='_blank'>
					<TwitterIcon />
				</a>
			</li>
			<li className="icon ">
				<a href={COMPANY_LINKEDIN} rel='noreferrer' target='_blank'>
					<LinkedinIcon />
				</a>
			</li>
			<li className="icon ">
				<a href={COMPANY_FACEBOOK} rel='noreferrer' target='_blank'>
					<FacebookIcon />
				</a>
			</li>
			
			<li className="icon ">
				<a href={COMPANY_YOUTUBE} rel='noreferrer' target='_blank'>
					<YouTubeIcon />
				</a>
			</li>

			{/* <li className="icon ">
				<Link href="/login" rel='noreferrer'>
					<LoginIcon />
				</Link>
			</li> */}
			
		</ul>
	);
};

export default SocialMedias;
